const digest = 'defb4ed00c33fef3fbb7c49d25a2b876ee5c51ceb8871323451609350b162bdb';
const css = `._sideImageContainer_1cf1o_1{height:15rem}._bottomImageContainer_1cf1o_8,._sideImageContainer_1cf1o_1{background-position:50%;background-size:cover;overflow:hidden}._bottomImageContainer_1cf1o_8{height:11.25rem}._locationTag_1cf1o_15{background-color:hsla(0,0%,45%,.8);top:0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'sideImageContainer': '_sideImageContainer_1cf1o_1', 'bottomImageContainer': '_bottomImageContainer_1cf1o_8', 'locationTag': '_locationTag_1cf1o_15' };
export const sideImageContainer = '_sideImageContainer_1cf1o_1';
export const bottomImageContainer = '_bottomImageContainer_1cf1o_8';
export const locationTag = '_locationTag_1cf1o_15';
export { css, digest };